import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

export const organizationPolicy = createCrudVuexModule({
  namespaced: true,
  path: "/policy",
  persistent: [],
  state: {
    form: undefined,
    policy: undefined,
    policyId: undefined,
    isCreating: false,
    isEditing: false,
    isDownloading: false,

    selectedCategoryFilter: undefined,
  },
  getters: {
    isDownloading: (state) => state.isDownloading,
    form: (state) => state.form,
    policy: (state) => state.policy,
    policyId: (state) => state.policyId,
    isCreating: (state) => state.isCreating,
    isEditing: (state) => state.isEditing,
    isReading: (state) => !state.isEditing && !state.isCreating,

    selectedCategoryFilter: (state) => state.selectedCategoryFilter,
  },
  mutations: {
    isDownloading: (state, value) => (state.isDownloading = value),
    form: (state, value) => (state.form = value),
    policy: (state, value) => (state.policy = value),
    policyId: (state, value) => (state.policyId = value),
    selectedCategoryFilter: (state, value) => (state.selectedCategoryFilter = value),

    isCreating: (state, value) => {
      state.isCreating = value;

      state.policyId = undefined;
      state.policy = undefined;
      state.isEditing = false;
      state.form = {};
    },
    isEditing: (state, value) => {
      state.isEditing = value;
      if (value) {
        state.isCreating = false;
      }
    },
    reset: (state, value) => {
      state.policyId = undefined;
      state.policy = undefined;
      state.isEditing = false;
      state.isCreating = false;
      state.form = {};
    },
    resetFilters: (state, value) => {
      state.selectedCategoryFilter = undefined;
    },
    removePolicyFromPagination: (state, id) => {
      state.pagination.docs = state.pagination.docs.filter((i) => i._id != id);
    },
  },

  actions: {
    async download({ commit }, payload) {
      commit("isDownloading", true);
      try {
        const response = await rest.post("/policy/download", payload);
        return response;
      } finally {
        commit("isDownloading", false);
      }
    },

    async changePolicyStatus({ commit }, id) {
      commit("isUpdating", true);
      try {
        return rest.put(`/policy/status`, { id: id });
      } finally {
        commit("isUpdating", false);
      }
    },
    async fetchDetail({ getters, commit, dispatch }, id) {
      try {
        commit("isLoading", true);
        const response = await rest.get(`/policy/${id}`);
        commit("policy", response.data);

        return response.data;
      } finally {
        commit("isLoading", false);
      }
    },
    async delete({ commit, dispatch }, payload) {
      try {
        //silmiyoruz statusun notapplicable yapıyoruz
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", { editedEntity: {}, form: payload });
        const response = await rest.post(`/policy/delete`, payload);
        return response.data;
      } finally {
        commit("isUpdating", false);
      }
    },

    async revertDeleted({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", { editedEntity: {}, form: payload });
        const response = await rest.post(`/policy/revert-deleted`, payload);

        return response.data;
      } finally {
        commit("isUpdating", false);
      }
    },
    async fetchDetailAndUpdateOnPaginate({ getters, commit, dispatch }, id) {
      try {
        const response = await rest.get(`/policy/${id}`);

        commit("pagination", {
          ...getters.pagination,

          docs: getters.pagination.docs.map((i) => {
            if (i._id == id) {
              return response.data;
            }
            return i;
          }),
        });

        return response.data;
      } finally {
        commit("isLoading", false);
      }
    },
  },
});
